import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FileManagementComponent } from '@app/file-management/file-management.component';

const routes: Routes = [
  {path: 'fileManagement', component: FileManagementComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
